import { z } from 'zod';

export const runDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'a run date is YYYY-MM-DD');

export type RunDate = z.infer<typeof runDateSchema>;

/** The calendar date an instant falls on in a time zone, as YYYY-MM-DD. */
export function runDateIn(instant: Date, timeZone: string): RunDate {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(instant);
  const part = (type: 'year' | 'month' | 'day') =>
    parts.find((candidate) => candidate.type === type)?.value ?? '';
  return `${part('year')}-${part('month')}-${part('day')}`;
}
